import React from 'react'
import axios from "axios";
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import ROUTES from '../../nav/Routes';


const ContactDetail = () => {
    let { id } = useParams();
    const [ContactObject, setContactObject] = useState({});

    useEffect(() => {
        axios.get(`
           https://manncarriers.com/server/contactGetById.php?id=${id}`
           // http://localhost:8080/mann/contactGetById.php?id=${id}`
            ).then((response) => {
            console.log(response.data.data);
            setContactObject(response.data.data);
        })
    }, [id]);
    
    return (
        <div>
            <h2>Contact Detail</h2>
            <div>
                <dl className="dl-horizontal">
                    <div className="AdminAlign">
                        <dt>
                            Name
                        </dt>

                        <dd>

                            <p>{ContactObject.name}</p>

                        </dd>
                    </div>
                    <div className="AdminAlign">

                        <dt>Email

                        </dt>

                        <dd>

                            <p>{ContactObject.email}</p>

                        </dd>
                    </div>
                    <div className="AdminAlign">

                        <dt>
                            Subject
                        </dt>

                        <dd>

                            <p>{ContactObject.subject}</p>

                        </dd>
                    </div>
                    <div className="AdminAlign">

                        <dt>
                            Massage
                        </dt>

                        <dd>

                            <p>{ContactObject.msg}</p>

                        </dd>
                    </div>
                    <div className="AdminAlign">

                        <dt>
                            Date
                        </dt>

                        <dd>

                            <p>{ContactObject.datetime}</p>


                        </dd>
                    </div>
                </dl>
                <Link to={ROUTES.contactlist.name}>Go Back</Link>
            
            </div>
        </div>
    )
}

export default ContactDetail;